import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/requisicao-pendente-permissao`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        historico: {
            datatable(queryParms = {}) {

                return repository.get(`${baseUrl}/datatable-historico?${urlUtil.serialize(queryParms)}`)
            },
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        permissao: {
            datatable(queryParms = {}) {

                return repository.get(`${baseUrl}/datatable-permissao?${urlUtil.serialize(queryParms)}`)
            },
            getMateriais(centroCustoRequisitanteId) {

                return repository.get(`${baseUrl}/material-permissao/${centroCustoRequisitanteId}`)
            },
            storePermissoes(params) {

                return repository.post(`${baseUrl}/store-permissao`, params)
            },
            createImportacao(centroCustoDestinoId) {

                return repository.get(`${baseUrl}/create-importacao-permissao/${centroCustoDestinoId}`)
            },
            storeImportacao(params) {

                return repository.post(`${baseUrl}/store-importacao-permissao`, params)
            },
        },
    }
}